<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <insertForm :formSchema="formSchema" v-on:emitForm="close"></insertForm>

    <v-card-title>
      <h2>Yearly Project Budget</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.budget_category }}</td>
        <td class="text-xs-left">{{ props.item.budgeting_year }}</td>
        <td class="text-xs-left">{{ changeFormateDMY(props.item.start_date) }}</td>
        <td class="text-xs-left">{{ changeFormateDMY(props.item.end_date) }}</td>
        <td class="text-xs-left">{{ props.item.document_name }}</td>

         <td class="text-xs-left">
          <v-btn v-if="props.item.projectDoc_id" icon class="mx-0" @click="downloadFile(props.item.document_file_name)">
            <v-icon color="purple">image</v-icon>
          </v-btn>
          <v-btn v-else icon disabled class="mx-0" title="Empty File">
            <v-icon color="purple">image</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-left">{{ props.item.revision_date }}</td>

        <td class="text-xs-left">         
        <span v-if="props.item.is_active" class="active">Yes</span>           
        <span v-else class="in-active">No</span>            
        </td> 

        <td class="justify-center layout px-0">
         
          <v-btn icon title="View Details" class="mx-0" @click="viewDetails(props.item.id)">
            <v-icon color="teal">remove_red_eye</v-icon>
          </v-btn>

          <v-btn icon title="Edit" class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>

          <v-btn v-if="props.item.revision != 1" icon class="mx-0" title="Revision" @click="editItem(props.index, props.item,1)">
            <v-icon>rate_review</v-icon>
          </v-btn>

          <!-- <v-btn v-if="props.item.revision != 1" icon class="mx-0" title="Revision" @click="editItem(props.index, props.item,1)">
            <v-icon>rate_review</v-icon>
          </v-btn>
          <v-btn v-else icon class="mx-0" title="Revisied" @click="archived">
            <v-icon color="error">rate_review</v-icon>
          </v-btn> -->

          <v-btn icon title="Delete" class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>

          <v-btn icon class="mx-0" title="Add Detail" @click="addDetails(props.index, props.item.id)">
            <v-icon color="info">details</v-icon> 
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <YearlyDataTableArchive ref="archiveList"></YearlyDataTableArchive>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import insertForm from "./insertForm";
import YearlyDataTableArchive from "./yearlyDataTableArchive";
import Axios from "axios";
import ServerPath from "../../../server-path/server-path";

export default {
  components: {
    insertForm, YearlyDataTableArchive
  },

  data: () => ({
    valid: true,

    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      {
        text: "Budget Category",
        align: "left",
        sortable: true,
        value: "budget_category"
      },
      {
        text: "Budgeting Year",
        align: "left",
        sortable: true,
        value: "budgeting_year"
      },
      {
        text: "Start Date",
        align: "left",
        sortable: true,
        value: "start_date"
      },
      { text: "End Date", align: "left", sortable: true, value: "end_date" },      
      {
        text: "Related Document",
        align: "left",
        sortable: true,
        value: "document_name"
      },
      {
        text: "Upload File",
        align: "left",
        sortable: true,
        value: "upload_file_name"
      },
      { text: "Last Revised Date", align: "left", sortable: true, value: "revision_date" },
      {text: "Active", align: "left", sortable: true, value: "is_active"},
      { text: "Action", align: "center", value: "" }
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,
    
    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

    formSchema: {
      id: 0,
      budget_category:'',
      budgeting_year: "",
      start_date: "",
      end_date: "",
      document_name: "",
      remarks:'',
      is_active:0,
      revision:'',
      projectDoc_id:0,
      document_file_name:'',
    }
  }),

  /*------------Datatable------------*/

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },
  // mounted() {
  //   this.getDataFromApi().then(data => {
  //     this.desserts = data.items;
  //     this.totalDesserts = data.total;
  //   });
  // },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  methods: {

    viewDetails(id){
      let route = ServerPath.serverPath+'/yearly-pro-budget-details/'+id;
      window.open(route, '_blank');
    },

    archived(){
      this.SnackbarVal.color = "error"; 
      this.SnackbarVal.message = 'The same data has already been revised';
      this.SnackbarVal.snackbar = true;
    },

    addDetails(index, id)
    {
      sessionStorage.setItem("proId", id); 
      this.$router.push('/financial/yearly-pro-budget-detail');
    },

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "yearly-project-budget-list")
          .then(res => {
            let items = res.data;

            const total = res.totalRecords;
            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    downloadFile(fileName) {
      let url = ServerPath.serverPath+fileName;
      window.open(url);      
    },
    
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    editItem(index, item, revision=null) {
    
        //console.log("item == ", item);
        this.row_index = index
        this.formSchema = {...item};

        this.formSchema.revision = 0;
        if(revision==1)
        {
          this.formSchema.revision = 1;
        }

        this.formSchema.start_date = this.changeFormateDMY(
          item.start_date
          );
        this.formSchema.end_date = this.changeFormateDMY(
          item.end_date
          );

        /*this.formSchema.start_date = this.changeFormateDMY(
          this.formSchema.start_date
        );
        this.formSchema.end_date = this.changeFormateDMY(
          this.formSchema.end_date
        );
*/
        //console.log("formSchema == ", this.formSchema);

        window.scrollTo({
          top: 0,
          left: 100,
          behavior: "smooth"
        });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "yearly-project-budget").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
          this.getDataFromApi();
          this.SnackbarVal.color = "success"
        }
        else
        {
          this.SnackbarVal.color = "error"; 
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          $this.totalDesserts += 1;
          $this.desserts.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          $this.$set($this.desserts, $this.row_index, { ...res.data });
          $this.row_index = "";
        }
        this.SnackbarVal.color = "success"
      }
      window.scrollTo({
        left: 0,
        top:
          document.body.scrollHeight || document.documentElement.scrollHeight,
        behavior: "smooth"
      });
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/project_info/yearly_project_budget/dataTable.vue